export type Permit = {
  slugs: string[]
  can: (slug: string) => boolean
  reads: (slice: string) => boolean
  writes: (slice: string) => boolean
  readsEverything: (slice: string) => boolean
  writesEverything: (slice: string) => boolean
  decides: (slice: string) => boolean
}

export function permit(slugs: string[]): Permit {
  const held = new Set(slugs)
  const can = (slug: string) => held.has(slug)

  return {
    slugs,
    can,
    reads: (slice) => can(`${slice}.read`) || can(`${slice}.read.own`),
    writes: (slice) => can(`${slice}.manage`) || can(`${slice}.manage.own`),
    readsEverything: (slice) => can(`${slice}.read`),
    writesEverything: (slice) => can(`${slice}.manage`),
    decides: (slice) => can(`${slice}.manage`),
  }
}
